/**
 * Temporary graph-execution tracing. Flip `isGraphTracingEnabled` to false to
 * silence it without touching the call sites.
 */
export const isGraphTracingEnabled = true;
export function traceGraph(message, details) {
    if (!isGraphTracingEnabled)
        return;
    if (details === undefined) {
        console.log(`[graph] ${message}`);
        return;
    }
    console.log(`[graph] ${message}`, details);
}
export function traceGraphWarning(message, details) {
    if (!isGraphTracingEnabled)
        return;
    if (details === undefined) {
        console.warn(`[graph] ${message}`);
        return;
    }
    console.warn(`[graph] ${message}`, details);
}
/** Compact, log-friendly view of node data (Observables and long strings shortened). */
export function describeNodeData(data) {
    const described = {};
    for (const [key, value] of Object.entries(data)) {
        described[key] = describeValue(value);
    }
    return described;
}
function describeValue(value) {
    if (typeof value === 'string') {
        return value.length > 60 ? `${value.slice(0, 60)}…(${value.length})` : value;
    }
    if (value instanceof EventTargetLike)
        return '<EventTarget>';
    if (value && typeof value === 'object' && 'value' in value && isObservableLike(value)) {
        return { observable: describeValue(value.value) };
    }
    return value;
}
function isObservableLike(value) {
    return typeof value.addOnChangeListener === 'function';
}
/** `EventTarget` is missing in non-DOM test runners, so guard the reference. */
const EventTargetLike = typeof EventTarget === 'function' ? EventTarget : class {
};
